import React, { useState } from 'react';

function UrunlerMain() {
  const [selectedProduct, setSelectedProduct] = useState(null);

  const products = [
    {
      id: 1,
      name: 'KAVAK KERESTE',
      image: 'kavakkerestenew.jpeg',
      shortDesc: 'Hafif, yumuşak ve işlenmesi kolay orman ürünü',
      fullDesc: 'Kavak kereste, kavak ağacından (Populus türleri) elde edilen, hafif, yumuşak ve açık renkli bir kereste çeşididir. Türkiye\'de özellikle iç mekân ve ambalaj işlerinde sık kullanılır.',
      features: [
        'Hafiftir → Taşıması ve işlemesi kolaydır',
        'Yumuşaktır → Çivi, vida ve kesim işlemleri rahattır',
        'Açık renklidir → Boya ve kaplama iyi tutar',
        'Reçinesizdir → Temiz yüzey verir',
        'Çabuk kurur, ancak iyi kurutulmazsa eğilme yapabilir'
      ],
      uses: [
        'İnşaat kalasları ve kirişler',
        'Çatı ve iskele yapımı',
        'Mobilya iskeleti (koltuk, kanepe içleri)',
        'Kapı kanadı iç dolgu',
        'Çekmece ve dolap içleri',
        'Ambalaj sandıkları',
        'Palet ve sandık yapımı',
        'Kontrplak ve MDF üretimi',
        'Tavan, lambri gibi hafif iç mekân uygulamaları'
      ]
    },
    {
      id: 2,
      name: 'ÇAM KERESTE',
      image: 'camkereste.jpeg',
      shortDesc: 'Dayanıklı, uzun ömürlü ve geniş alanda kullanılan kereste',
      fullDesc: 'Çam kereste, çam ağacından (Pinus türleri) elde edilen, Türkiye\'de en yaygın kullanılan kereste çeşitlerinden biridir. Dayanımı, bulunabilirliği ve fiyat/performans dengesiyle hem ustalar hem esnaf tarafından çok tercih edilir.',
      features: [
        'Orta sertliktedir → Kavaktan daha sağlamdır',
        'Reçinelidir → Doğal koruyucudur',
        'Sarımsı–kızılımsı renktedir → Damarları belirgindir',
        'İşlenmesi kolaydır → Kesim, çivi, vida rahat',
        'Doğru kurutulursa uzun ömürlüdür'
      ],
      uses: [
        'İnşaat kalasları ve kirişler',
        'Çatı ve iskele yapımı',
        'Kapı, pencere kasası',
        'Merdiven ve korkuluk',
        'Bahçe mobilyası (emprenyeli ise)',
        'Lambri, pergola, kamelya',
        'Palet ve sandık'
      ]
    }
  ];

  return (
    <div className="bg-white text-black w-full" id="drops">
      <div className="relative text-center py-6 md:py-8">
        <h1 className="text-3xl md:text-4xl font-bold text-gray-900">ÜRÜNLERİMİZ</h1>
      </div>
      
      <div className="flex flex-wrap justify-center items-stretch gap-6 md:gap-8 py-12 md:py-16 px-4 md:px-6 max-w-6xl mx-auto">
        {products.map((product) => (
          <div
            key={product.id}
            onClick={() => setSelectedProduct(product)}
            className="w-full sm:w-80 md:w-96 cursor-pointer transform transition-all duration-300 hover:scale-105 hover:shadow-2xl rounded-xl overflow-hidden border border-gray-200"
          >
            <div className="bg-white">
              {/* Resim */}
              <div className="relative h-64 md:h-72 overflow-hidden bg-gray-100">
                <img 
                  src={product.image} 
                  alt={product.name}
                  className="w-full h-full object-cover transition-transform duration-300 hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
              </div>

              {/* İçerik */}
              <div className="p-6">
                <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3">{product.name}</h2>
                <p className="text-gray-600 text-sm md:text-base leading-relaxed mb-6 line-clamp-3">
                  {product.shortDesc}
                </p>
                
                <button
                  onClick={() => setSelectedProduct(product)}
                  className="w-full bg-primary hover:bg-secondary text-white font-semibold py-2 md:py-3 px-4 rounded-lg transition-colors duration-300"
                >
                  Detaylı Bilgi
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Modal */}
      {selectedProduct && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
          onClick={() => setSelectedProduct(null)}
        >
          <div 
            className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Başlık */}
            <div className="sticky top-0 bg-gradient-to-r from-primary to-secondary text-white p-6 flex justify-between items-center">
              <h2 className="text-2xl md:text-3xl font-bold">{selectedProduct.name}</h2>
              <button
                onClick={() => setSelectedProduct(null)}
                className="text-white hover:bg-white/20 rounded-full p-2 transition-colors duration-300"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            {/* İçerik */}
            <div className="p-6 md:p-8">
              <div className="mb-6">
                <img 
                  src={selectedProduct.image} 
                  alt={selectedProduct.name}
                  className="w-full h-80 object-cover rounded-lg mb-6"
                />
                <p className="text-gray-700 text-base md:text-lg leading-relaxed">
                  {selectedProduct.fullDesc}
                </p>
              </div>

              {/* Bilgi Kutuları */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
                  <h3 className="font-semibold text-gray-900 mb-3 flex items-center gap-2">
                    <span className="text-xl">✓</span>
                    Özellikleri
                  </h3>
                  <ul className="text-gray-700 text-sm space-y-2">
                    {selectedProduct.features && selectedProduct.features.map((feature, idx) => (
                      <li key={idx} className="flex gap-2">
                        <span className="text-primary font-bold">•</span>
                        <span>{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="bg-green-50 p-4 rounded-lg border border-green-200">
                  <h3 className="font-semibold text-gray-900 mb-3 flex items-center gap-2">
                    <span className="text-xl">🏗️</span>
                    Kullanım Alanları
                  </h3>
                  <ul className="text-gray-700 text-sm space-y-2">
                    {selectedProduct.uses && selectedProduct.uses.slice(0, 7).map((use, idx) => (
                      <li key={idx} className="flex gap-2">
                        <span className="text-primary font-bold">→</span>
                        <span>{use}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              {/* Butonlar */}
              <div className="flex gap-4">
                <button
                  onClick={() => setSelectedProduct(null)}
                  className="flex-1 bg-gray-200 hover:bg-gray-300 text-gray-900 font-semibold py-3 rounded-lg transition-colors duration-300"
                >
                  Kapat
                </button>
                <a
                  href="/iletisim"
                  className="flex-1 bg-primary hover:bg-secondary text-white font-semibold py-3 rounded-lg transition-colors duration-300 text-center"
                >
                  İletişime Geç
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default UrunlerMain;